import React, { useState, useEffect, useRef, useMemo } from "react";
import { Input, Empty } from 'antd';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { generateClassName } from "jzfz-web-utils";
import { constantConfig, commonUtil } from 'web-common';
import { getQueryParams, ObjTest } from "../../util/common";
import { CommonSearch } from '../../component/commonSearch';
import { CategoryTabs } from '../../component/categoryTabs/CategoryTabs';
import { queryMenuContentList } from '../../store/action';
import { MenuItemVo } from "../../config/menus";
import { ViewportImg } from '../../component/viewportImg';

import './style/index.less';


const pcBanner = require('../../assets/images/news/newsPCBanner.jpg');
const mobileBanner = require('../../assets/images/news/newsMobileBanner.jpg');

const { ModuleTypeEnum, WEBSITE_PATHS } = constantConfig;
const { waterColumnsArray } = commonUtil;


// 列表子项边距
const MARGIN = 40;


/**
 * 动态,新闻
 */
const News = () => {
	const { menuId = null } = getQueryParams();
	const history = useHistory();
	const { menus, isMobile } = useSelector((state: any) => state.reducer);
	const [contentList, setContentList] = useState<any[]>([]);
	const [activeKey, setActiveKey] = useState<string>(null);
	const containerRef = useRef<any>(null);
	// 设置渲染的列数
	const columnCount = useMemo(() => isMobile ? 1 : 3, [isMobile]);

	const currentModule = menus.find((v: MenuItemVo) => v.module === ModuleTypeEnum.NEWS);


	useEffect(() => {
		setActiveKey(menuId);
	}, [menuId]);


	// 初始化数据
	useEffect(() => {
		initData();
	}, [activeKey]);


	/**
	 * 初始化方法
	 */
	const initData = async () => {
		const result = await queryMenuContentList(ModuleTypeEnum.NEWS, activeKey);
		const arrs = result.data || [];
		if (Array.isArray(arrs)) {
			setContentList(arrs);
		}
	};


	/**
	 * 计算列的宽度
	 * @param item
	 */
	const getColumnWidth = () => {
		if (isMobile) {
			return '100%';
		}
		if (containerRef.current && columnCount) {
			const width = containerRef.current.offsetWidth;
			const marginCount = MARGIN * (columnCount - 1);
			return (width - marginCount) / columnCount;
		}
		return 0;
	};


	/**
	 * 打开新闻动态链接
	 * @param jumpAddress 
	 */
	const openNewsLink = (jumpAddress: string) => {
		window.open(jumpAddress, '_blank');
	};


	/**
	 * 渲染搜索框
	 */
	const renderSearch = () => {
		const SearchInput = (
			<CommonSearch 
				onSearch={(value) => {
					value && history.replace(`${WEBSITE_PATHS.search}?value=${value}`);
				}} 
			/>
		);
		if (isMobile) {
			return (
				<div className="mt16 mb24 plr16">
					<div>{SearchInput}</div>
				</div>
			);
		}
		return (
			<div className="flexjs mt36 mb24 plr72">
				<div title="占位" />
				<div style={{width: 200}}>{SearchInput}</div>
			</div>
		);
	};


	return (
		<div className="company-news-wrapper">
			{/* banner */}
			<div className="w ofh">
				<img src={isMobile ? mobileBanner : pcBanner} loading="lazy" className="w" />
			</div>

			{/* content */}
			<div>
				{/* 分类tabs */}
				<div 
					className={generateClassName([
						isMobile ? "p16" : "ptb24 plr72"
					])}
				>
					<CategoryTabs 
						options={currentModule.children || []} 
						activeKey={activeKey}
						onChange={(tabKey: string) => {
							setActiveKey(tabKey);
							history.replace(WEBSITE_PATHS.news);
						}}
					/>
				</div>

				{/* search */}
				{/* {renderSearch()} */}

				{/* 内容 */}
				<div className={generateClassName([isMobile ? "plr16" : "plr72"])}>
					
					<div className="w flexjs">
						<div className="flex1">
							<div className="top-line" />
							<div className="w pt12 pb40 flex" ref={containerRef}>
								{
									(waterColumnsArray(contentList, columnCount) || []).map((columns: any[], columnsIndex: number) => {
										return (
											<div 
												key={columnsIndex}
												className="new-column"
												style={{ width: getColumnWidth(), marginLeft: columnsIndex > 0? MARGIN : 0 }}
											>
												{
													ObjTest.isNotEmptyArray(columns) ? (
														columns.map((v, vi) => {
															if (!v) { return null;}
															const { title, jumpAddress, showDate, coverImage } = v;
															return (
																<div className="mb40" key={vi} onClick={() => openNewsLink(jumpAddress)}>
																	<ViewportImg src={coverImage} className="w" />
																	<div className="flexjs ptb5">
																		<div className="name eps2 f18">{title}</div>
																		<div className="other flexie lh28 f12 tr">
																			<div title="占位" />
																			<div className="w date">{showDate}</div>
																		</div>
																	</div>
																</div>
															);
														})
													) : (
														null
													)
												}
											</div>
										);
									})
								}
							</div>
						</div>
						{
							// 移动设备时不显示这个列表
							!isMobile ? (
								<div className="news-texts-content-list ml24" style={{width: 420}}>
									{
										(contentList || []).map((v, i) => (
											<div key={i} className="mt12 flexic flexjs crp row" onClick={() => openNewsLink(v.jumpAddress)}>
												<p className="eps f14 mr12 item-title">{v.title}</p>
												<span className="w100 f14 tr" style={{whiteSpace: 'nowrap'}}>{v.showDate}</span>
											</div>
										))
									}
								</div>
							) : (null)
						}
					</div>
				</div>
			</div>
		</div>
	)
}


export default News;
